module.exports = __webpack_public_path__ + "img/effet-points-colonne-2.5d2031dd.png";